import { createApi } from "@ametie/vue-muza-use";
import { useToast } from "@app/core";
import * as Sentry from "@sentry/vue";
import { DefaultApolloClient, provideApolloClient } from "@vue/apollo-composable";
import { createPinia } from "pinia";
import { createApp } from "vue";

import App from "./App.vue";
import router from "./router";

import "@app/core/style.css";
import "./main.scss";
import { apolloClient } from "@/shared/api/apolloClient";
import { myAxios } from "@/shared/config/axios";

const { error } = useToast();
const pinia = createPinia();
const app = createApp(App);

const isSentryEnabled = import.meta.env.VITE_SENTRY_ENABLED?.toUpperCase() === "TRUE";
const sentryDSN = import.meta.env.VITE_SENTRY_DSN;

if (isSentryEnabled) {
  Sentry.init({
    app,
    dsn: sentryDSN,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.3,
    tracePropagationTargets: ["localhost", /^https:\/\/pim\.api\.soinsider\.com\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.3,
  });
}

app.use(pinia);
app.use(router);
app.use(createApi({
  axios: myAxios, onError: (errorMessage) => {
    if (errorMessage.message === "Token is expired"
      || errorMessage.message === "Token is invalid") return;
    error(errorMessage.message);
  },
}));

// provideApolloClient — module-level fallback so composables work in Pinia stores and route guards
provideApolloClient(apolloClient);

// app.provide — component-tree injection for @vue/apollo-composable within components
app.provide(DefaultApolloClient, apolloClient);

app.mount("#app");
